/**
 * Creator for permission checks directives
 *
 * @param {Number} permissionType - a permission type to check
 * @returns {function(*=, *=, *): {link: link}}
 */
export function permissionDirectiveCreator(permissionType) {
  return function ($compile, permissionService) {
    return {
      link: (scope, element, attrs) => {
        permissionService.hasPermission(permissionType).then((hasPermission) => {
          if (!hasPermission) {
            attrs.$set('ngIf', false);
            $compile(element)(scope);
          }
        });
      }
    };
  };
}
